import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  newSchedule: {
    id: 'schedules.classtivity-schedule-form.new-schedule',
    defaultMessage: 'Add new schedule',
  },
  addStartTime: {
    id: 'schedules.classtivity-schedule-form.add-start-time',
    defaultMessage: 'Add start time',
  },
  removeStartTime: {
    id: 'schedules.classtivity-schedule-form.remove-start-time',
    defaultMessage: 'Remove start time',
  },
  classLabel: {
    id: 'schedules.classtivity-schedule-form.class-label',
    defaultMessage: 'Class',
  },
  durationLabel: {
    id: 'schedules.classtivity-schedule-form.duration-label',
    defaultMessage: 'Duration',
  },
  startTimeLabel: {
    id: 'schedules.classtivity-schedule-form.start-time-label',
    defaultMessage: 'Start time',
  },
  applyButton: {
    id: 'schedules.classtivity-schedule-form.apply-button',
    defaultMessage: 'Apply',
  },
  repeatWeeklyLabel: {
    id: 'schedules.classtivity-schedule-form.repeat-weekly-label',
    defaultMessage: 'Repeat weekly?',
  },
  startDateLabel: {
    id: 'schedules.classtivity-schedule-form.start-date-label',
    defaultMessage: 'Start date',
  },
  endDateLabel: {
    id: 'schedules.classtivity-schedule-form.end-date-label',
    defaultMessage: 'End date',
  },
  dow: {
    id: 'schedules.classtivity-schedule-form.dow',
    defaultMessage: '{dateTime, date, dow}',
  },
  startDateAfterEndDate: {
    id: 'schedules.classtivity-schedule-form.start-date-after-end-date',
    defaultMessage: 'The start date cannot be after the end date',
  },
  publish: {
    id: 'schedules.classtivity-schedule-form.publish',
    defaultMessage: 'Publish',
  },
  selectClass: {
    id: 'schedules.classtivity-schedule-form.select-class',
    defaultMessage: 'Select class',
  },
  reset: {
    id: 'schedules.classtivity-schedule-form.reset',
    defaultMessage: 'Reset',
  },
  allDaysSelected: {
    id: 'schedules.classtivity-schedule-form.add-days-selected',
    defaultMessage: 'All days of week',
  },
  xDaysSelected: {
    id: 'schedules.classtivity-schedule-form.x-days-selected',
    defaultMessage: '{daysCount, plural, one {# day} other {# days}} selected',
  },
  daysLabel: {
    id: 'schedules.classtivity-schedule-form.recurrence-days',
    defaultMessage: 'Days',
  },
  addClass: {
    id: 'schedules.classtivity-schedule-form.add-class',
    defaultMessage: 'Add a new class',
  },
  recurrenceDaysRequired: {
    id: 'schedules.classtivity-schedule-form.recurrence-days-required',
    defaultMessage: 'Please select at least one day.',
  },
});

export const confirmPublishModalMessages = defineMessages({
  title: {
    id: 'schedules.classtivity-scheduler.confirm-publish-modal.title',
    defaultMessage: 'Publish schedules',
  },
  accept: {
    id: 'schedules.classtivity-scheduler.confirm-publish-modal.accept',
    defaultMessage: 'Publish',
  },
  body: {
    id: 'schedules.classtivity-scheduler.confirm-publish-modal.body',
    defaultMessage:
      'Are you sure you want to create {schedulesCount, plural, one {# new class schedule} other {# new class schedules}}?',
  },
});

export const publishSuccessModalMessages = defineMessages({
  title: {
    id: 'schedules.classtivity-scheduler.publish-success-modal.title',
    defaultMessage: 'Your schedules are being published',
  },
  body: {
    id: 'schedules.classtivity-scheduler.publish-success-modal.body',
    defaultMessage: 'Publishing can take up to 15 minutes, so check back later.',
  },
  accept: {
    id: 'schedules.classtivity-scheduler.publish-success-modal.accept',
    defaultMessage: 'Got it',
  },
});
